import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { Fragment } from 'react'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions'
import CadastrarImovelView from 'view/cadastro-imovel/CadastrarImovelView'
import EditarImovelView from 'view/cadastro-imovel/EditarImovelView'
import { VisualizarImovelView } from 'view/visualizacao-imovel/VisualizarImovelView'

import { VisualizacaoTerritorialView } from './VisualizacaoTerritorialView'

export function VisualizacaoTerritorialRootView() {
  const match = useRouteMatch()

  return (
    <Fragment>
      <Breadcrumb title='Acompanhamento do território' />
      <PecSwitch>
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}`}
          exact
          component={VisualizacaoTerritorialView}
        />
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}/visualizarImovel/:imovelId(\\d+)`}
          component={VisualizarImovelView}
        />
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}/cadastrarImovel`}
          component={CadastrarImovelView}
          exact
        />
        <PrivateRoute
          permission={Permissions.gestaoDeCadastros.acompanhamentoDoTerritorio}
          path={`${match.url}/editarImovel/:imovelId(\\d+)`}
          exact
          component={EditarImovelView}
        />
      </PecSwitch>
    </Fragment>
  )
}
